<div class="container">
  <mic-breadcrumb id="free-repair-setup-breadcrumb">
    <mic-breadcrumb-link link="/home/dashboard" icon="home"></mic-breadcrumb-link>
    <mic-breadcrumb-link label="{{ translationService.translate('productDataText') }}"></mic-breadcrumb-link>
    <mic-breadcrumb-link
      link="/home/productData/freeRepair"
      label="{{ translationService.translate('freeRepairText') }}"
    ></mic-breadcrumb-link>
    <mic-breadcrumb-link label="{{ translationService.translate('freeRepairsSetupText') }}"></mic-breadcrumb-link>
  </mic-breadcrumb>

  <h3 class="m-0 mt-3" id="free-repair-setup-heading">{{ translationService.translate('freeRepairsSetupText') }}</h3>

  <mic-spinner-overlay ariaLabel="In Progress" color="primary" [loading]="isCreateInProgress">
    <mat-card class="search-card mt-3">
      <div class="filters flex flex-row justify-between items-start sm-flex-col gap-4 setup-card-row">
        <form [formGroup]="freeRepairsSetupFormGroup" class="setup-form">
          <div class="setup-fields-row">
            <div class="edit-component setup-field">
              <mat-form-field class="w-full" id="codeField" subscriptSizing="dynamic">
                <mat-label class="custom-label-error">{{ translationService.translate('codeText') }} </mat-label>
                <input
                  id="code"
                  matInput
                  type="text"
                  required
                  form
                  formControlName="code"
                  value="{{ code }}"
                  (keydown.enter)="$event.preventDefault()"
                  (blur)="checkIfFreeRepairCodeExists()"
                  maxlength="20"
                />
                @if (freeRepairsSetupFormGroup.get('code').hasError('required')) {
                <mat-error>{{ translationService.translate('thisIsMandatoryFieldText') }}</mat-error>
                } @if (freeRepairsSetupFormGroup.get('code').hasError('exists')) {
                <mat-error>{{ translationService.translate('codeExistsText') }}</mat-error>
                }
              </mat-form-field>
            </div>

            <div class="edit-component setup-field setup-field--spaced">
              <mat-form-field appearance="fill" class="w-full" id="descriptionField" subscriptSizing="dynamic">
                <mat-label class="custom-label-error">{{ translationService.translate('descriptionText') }} </mat-label>
                <input
                  id="description"
                  matInput
                  type="text"
                  formControlName="description"
                  value="{{ description }}"
                  maxlength="35"
                  required
                />
                @if (freeRepairsSetupFormGroup.get('description').hasError('required')) {
                <mat-error>{{ translationService.translate('thisIsMandatoryFieldText') }}</mat-error>
                }
              </mat-form-field>
            </div>
            <div class="edit-component setup-field setup-field--spaced">
              <mat-form-field appearance="fill" class="w-full" id="totalRepairsField" subscriptSizing="dynamic">
                <mat-label class="custom-label-error">{{ translationService.translate('freeRepairsTotalText') }} </mat-label>
                <input
                  id="totalRepairs"
                  matInput
                  type="text"
                  formControlName="totalRepairs"
                  value="{{ totalRepairs }}"
                  pattern="^[1-9][0-9]*$"
                  required
                  maxlength="2"
                  (keydown)="preventNegativeInput($event)"
                  (input)="enforceMaxLength($event, 2)"
                  (blur)="checkValidTotalRepairs()"
                />
                @if (freeRepairsSetupFormGroup.get('totalRepairs').hasError('invalid')) {
                <mat-error>{{ translationService.translate('thisIsMandatoryFieldText') }}</mat-error>
                }
              </mat-form-field>
            </div>
          </div>
        </form>
        <div class="action-bar">
          <button id="cancel" class="btn-cancel" mat-flat-button (click)="cancel()">
            <mat-icon>cancel</mat-icon> {{ translationService.translate('cancelLinkText') }}
          </button>
          @if (!isCreateMode && !isCopyAs) {
          <button mat-flat-button class="btn-primary" id="assign-button" type="button" (click)="assign()">
            <mat-icon>refresh</mat-icon>{{ translationService.translate('assignText') }}
          </button>
          }
          <span
            [matTooltip]="
              productSaveDisabled
                ? this.translationService.translate('comingSoonText')
                : !saveEnabled
                ? this.translationService.translate('userCannotSaveText')
                : !isModified
                ? this.translationService.translate('noModifiedText')
                : null
            "
            matTooltipPosition="above"
          >
            <button
              id="save"
              type="button"
              mat-flat-button
              class="btn-primary"
              color="primary"
              [disabled]="!saveEnabled || !isModified"
              (click)="save()"
            >
              <mat-icon>save</mat-icon>
              {{ translationService.translate('saveLinkText') }}
            </button>
          </span>
        </div>
      </div>
    </mat-card>

    <div id="finished-product-table" class="cam-table table-container">
      <mic-table #paginatedTable class="table-stripped" [config]="tableConfig" [dataSource]="dataSource">
        <ng-container *micTableNoData>
          <mic-empty-state icon="layers_clear" title="{{ translationService.translate('emptyTableText') }}"></mic-empty-state>
        </ng-container>
        <ng-container *micCellTemplate="let item; name: 'qty'">
          <input
            id="quantityInput"
            matInput
            type="text"
            min="0"
            step="1"
            pattern="^[0-9]*$"
            maxlength="2"
            [formControl]="getControl(item, 'qty')"
            (keydown)="handleKeydown($event)"
          />
        </ng-container>
      </mic-table>
    </div>
  </mic-spinner-overlay>

  <mic-modal class="modalC" #discardConfirmation (result)="onDiscardModalClosed($event)"></mic-modal>
  <ng-template #discardContent>{{ translationService.translate('unSaveChangesText') }}</ng-template>
</div>
